import { render, staticRenderFns } from "./AppTableList.vue?vue&type=template&id=8edd6e70"
import script from "./AppTableList.vue?vue&type=script&lang=js"
export * from "./AppTableList.vue?vue&type=script&lang=js"
import style0 from "./AppTableList.vue?vue&type=style&index=0&id=8edd6e70&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports